import {useMemo} from 'react';
import {FormatDateOptions, useIntl} from 'react-intl';

import {useOverallInfo} from '@components/_context';

const DATE_FORMAT = {month: 'long', day: '2-digit', weekday: 'long'};

export const useNextBoxDate = (): {raw: Date | undefined; formatted: string} => {
  const {formatDate} = useIntl();
  const {estimatedCarrierDeliveryAt} = useOverallInfo();
  return useMemo(() => {
    return {
      raw: estimatedCarrierDeliveryAt ? new Date(estimatedCarrierDeliveryAt) : undefined,
      formatted: estimatedCarrierDeliveryAt
        ? formatDate(estimatedCarrierDeliveryAt, DATE_FORMAT as FormatDateOptions)
        : '',
    };
  }, [formatDate, estimatedCarrierDeliveryAt]);
};
